import moment from 'moment';
import * as React from 'react';

import { SummaryItem } from '~/components/MyWorkspace/SummaryItem';
import { People } from '~/services/Http';

export interface Props {
  listItem: People.TrainingDto;
  isTabDisabled?: boolean;
}

export const Training: React.FC<Props> = ({ listItem, isTabDisabled }) => (
  <SummaryItem
    key={listItem.key.id}
    avatarProps={{
      alt: listItem.employee.firstName,
      src: listItem.employee.profilePic,
    }}
    primaryElement={`${listItem.employee.firstName} ${listItem.employee.lastName}`}
    secondaryElement={`${listItem.title}, ${moment(listItem.startDate).format(
      'L',
    )}${listItem.endDate ? ` - ${moment(listItem.endDate).format('L')}` : ''}`}
    href={
      !isTabDisabled
        ? `/page-ui2-redirect?empId=${listItem.employee.id}&area=development&subarea=DEV_EDUCATION`
        : ''
    }
  />
);
